





define(['http',
    '../stylesParser',
    './relativeToAbsolutePathConverter',
    'security',
    'mainConfig',
    'services/utils'],
function(http,
    stylesParser,
    relativeToAbsolutePathConverter,
    security,
    mainConfig,
    Utils) {
    'use strict';

    var originalSetStyle;

    /**
     * @ignore
     * @param {String} url
     * @param {Function} callback
     */
    function requestStyle(url, callback) {
        http.get({
            url: url,
            callback: callback
        });
    }

    function validateAndSetStyle(styleDefinition, options) {
        var apiKey, styleParserOptions, fallbackResourceUrlReqex, setStyle;
        options = options || {};
        apiKey = security.getKey(options.securityKeyName);
        styleParserOptions = {
            apiKey: apiKey,
            language: options ? options.language : undefined,
            geopolView: options ? options.geopolView : undefined,
            resourceUrls: options && options.resourceUrls ? {
                glyphs: relativeToAbsolutePathConverter.convert(options.resourceUrls.glyphs),
                sprite: relativeToAbsolutePathConverter.convert(options.resourceUrls.sprite)
            } : undefined
        };
        fallbackResourceUrlReqex = /https:\/\/api.tomtom.com\/maps-sdk-js\/\d*\.\d*\.\d*\/glyphs/g;
        setStyle = function() {
            if (styleParserOptions.resourceUrls &&
                fallbackResourceUrlReqex.test(styleParserOptions.resourceUrls.glyphs)) {
                console.warn('You should host glyphs and sprites on your own.', '\n',
                    'During map initialization pass glyphs and sprites urls', '\n',
                    'var map = tomtom.map("map", {', '\n',
                    'key: "<your-tomtom-API-key>",', '\n',
                    'source: "vector",', '\n',
                    'basePath: <your-tomtom-sdk-base-path>,', '\n',
                    'glyphsUrl: <your-glyphs-URL>,', '\n',
                    'spriteUrl: <your-sprite-URL>', '\n',
                    '});', '\n',
                    'If you set basePath correctly the SDK will try to load glyphs and sprites',
                    'from there and you will not need to set the URL explicitly.'
                );
            }

            originalSetStyle.call(this, stylesParser(styleDefinition, styleParserOptions), options);
        };

        setStyle = setStyle.bind(this);

        /**
         * @ignore
         * Try to load sprite from the provided resource url. If it fails switch to hosted glyphs and sprites.
         * If url is not provided set provided style as it is.
         */
        if (styleParserOptions.resourceUrls && styleParserOptions.resourceUrls.sprite) {
            http.get({
                url: styleParserOptions.resourceUrls.sprite + '.json',
                callback: setStyle,
                fail: function() {
                    styleParserOptions.resourceUrls = {
                        glyphs: mainConfig['vector.glyphs'],
                        sprite: mainConfig['vector.sprites']
                    };
                    setStyle();
                }
            });
        } else {
            setStyle();
        }
    }

    /**
     * @ignore
     * @param {Object} styleDefinition
     * @param {Object} options
     */
    function setStyleDefinition(styleDefinition, options) {
        var that = this;
        if (options && options.preSetStyleCallback) {
            options.preSetStyleCallback(styleDefinition).then(function(styleDefinition) {
                validateAndSetStyle.call(that, styleDefinition, options);
            });
        } else {
            validateAndSetStyle.call(that, styleDefinition, options);
        }

    }

    /**
     * @ignore
     * @param {String} styleUrl
     * @param {Object} options
     */
    function setStyleDefinitionFromUrl(styleUrl, options) {
        var that = this;
        requestStyle(styleUrl, function(retrievedStyle) {
            setStyleDefinition.call(that, retrievedStyle, options);
        });
    }

    /**
     * @ignore
     * @param {Object} styleDefinition
     * @return {Boolean}
     */
    function isTomtomStyleObjectConfig(styleDefinition) {
        return typeof styleDefinition === 'object' && styleDefinition !== null && styleDefinition.styleUrlMapping;
    }

    /**
     * @ignore
     * @param {Object} styleDefinition
     * @return {String}
     */
    function resolveTomtomStyleUrl(styleDefinition) {
        var url = styleDefinition.styleUrlMapping[styleDefinition.theme.style][styleDefinition.theme.layer];
        return relativeToAbsolutePathConverter.convert(url);
    }

    /**
     * @ignore
     * @param {Object|String} styleDefinitionOrUrl
     * @param {Object} style.styleUrlMapping
     * @param {Object} [options]
     */
    function setStyle(styleDefinitionOrUrl, options) {
        if (isTomtomStyleObjectConfig(styleDefinitionOrUrl)) {
            options = options || {};
            options.resourceUrls = styleDefinitionOrUrl.resourceUrls;
            options.language = styleDefinitionOrUrl.language;
            options.geopolView = styleDefinitionOrUrl.geopolView;
            options.securityKeyName = styleDefinitionOrUrl.securityKeyName;
            options.preSetStyleCallback = styleDefinitionOrUrl.preSetStyleCallback;
            styleDefinitionOrUrl = resolveTomtomStyleUrl(styleDefinitionOrUrl);
        }

        // If a Style definition object is given
        if (typeof styleDefinitionOrUrl === 'object' && styleDefinitionOrUrl !== null) {
            setStyleDefinition.call(this, styleDefinitionOrUrl, options);

            // If an URL is given
        } else if (Utils.isString(styleDefinitionOrUrl)) {
            setStyleDefinitionFromUrl.call(this, styleDefinitionOrUrl, options);

        } else {
            originalSetStyle.call(this, styleDefinitionOrUrl, options);
        }
    }

    return {
        /**
         * @ignore
         * This method is used to enforce our styles to be loaded asynchronously and be passed to original mapboxgl
         * setStyle method LNS-10975
         * @param {Object} mapboxgl
         * @return {Function} Previously remembered setStyle function
         */
        modifySetStyle: function(mapboxgl) {
            var previousOriginalSetStyleFunction;
            if (!mapboxgl || mapboxgl.Map.prototype.setStyle === setStyle) {
                return null;
            }
            previousOriginalSetStyleFunction = originalSetStyle;
            originalSetStyle = mapboxgl.Map.prototype.setStyle;
            mapboxgl.Map.prototype.setStyle = setStyle;
            return previousOriginalSetStyleFunction;
        }
    };
});



// WEBPACK FOOTER //
// ./display/layers/vector/setStyleMethodModifier/mapboxSetStyleMethodModifier.js